import { render, staticRenderFns } from "./ServiceProviderSearch.vue?vue&type=template&id=89d0f75a&"
import script from "./ServiceProviderSearch.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports